import { ITable } from '../iTable/ITable';
import React, { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
import { getCommodityListByGUID } from '../../../../store/Commodity/actions';
import loadingGif from '../../../../assets/images/Innobo-Hub-loading.gif';
//redux
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
//----------------------------------------------------
import { Modal } from 'reactstrap';

import { getTableViewList } from '../../../../store/actions';
import PackingList from '../../PackingList/PackingList';
//-----------------------------------------------------------
const CommodityModal = (SelectGuid: any) => {
  const { groupName, visiblePackingList } = SelectGuid;
  const [popUpState, setpopUpState] = useState(false);
  const [dataGuid, setdataGuid] = useState<any>({});
  const [modal_xlarge, setmodal_xlarge] = useState(false);
  const [numOrder, setnumOrder] = useState('');
  const groupNameModal = 'commodityViewList';
  const valuesSizePagination = [10, 20, 30, 40, 50, 100];
  const { data, isLoading, milestoneConfig, selectGroupName } = useSelector(
    (state: any) => state.Commodity,
  );


  const [form, setForm] = useState({
    from: '',
    to: '',
    dynamicFilter: '',
  });

  //New object: Data Guid
  dataGuid.groupNameGUID = groupName == "cargoReleaseViewList" ? "cargoReleaseViewList" : selectGroupName;
  dataGuid.currentGUID = SelectGuid;

  const [CommodityList, setCommodityList] = useState<any[]>([]);
  const [tableConfig, setTableConfig] = useState([]);

  const [isCL, setCL] = useState(true)

  const dispatch = useDispatch();
  useEffect(() => {
    if (!modal_xlarge) {
      dispatch(getTableViewList({ groupName }));
    }
  }, [modal_xlarge, dispatch, groupName]);

  useEffect(() => {
    const myJSON = dataGuid.currentGUID.SelectGuid.Number;

    const currentOBJ = dataGuid.currentGUID.SelectGuid;
    const isCL = currentOBJ.hasOwnProperty('CLGUID');
    if (isCL) {
      console.log(' IT IS AN CL!');
      let number = '';
      if (
        currentOBJ.hasOwnProperty('CLPartNumber') &&
        currentOBJ.CLPartNumber != ''
      ) {
        number += ' Part #: ' + currentOBJ.CLPartNumber;
      }
      if (
        currentOBJ.hasOwnProperty('CLSalesOrderNumber') &&
        currentOBJ.CLSalesOrderNumber != ''
      ) {
        number += ' SO #: ' + currentOBJ.CLSalesOrderNumber;
      }
      if (
        currentOBJ.hasOwnProperty('CLWarehouseReceiptNumber') &&
        currentOBJ.CLWarehouseReceiptNumber != ''
      ) {
        number += ' WR #: ' + currentOBJ.CLWarehouseReceiptNumber;
      }
      setnumOrder(number);
    } else {
      setnumOrder(myJSON);
    }
  }, [SelectGuid]);

  useEffect(() => {
    let listFinal: any[] = [];
    listFinal = data; // transformCFColumnsData(data);
    setCommodityList(listFinal);
  }, [data]);


  useEffect(() => {
    if (data.length > 0) {
      const selectedGuid = dataGuid?.currentGUID?.SelectGuid.GUID;
      const selectedNumber = dataGuid?.currentGUID?.SelectGuid.Number;
      const clGUID = dataGuid?.currentGUID?.SelectGuid.CLGUID;
      console.log('VERJAN !!! , ', clGUID);
      const actualGuid = data[0]?.CLPurchaseOrderGUID;
      const actualNumber = data[0]?.CLSupplierPONumber;
      if (actualGuid == selectedGuid && actualNumber == selectedNumber) {
        console.log('SON LOS MISMOS!!!');
        return;
      }
    }
    const currentOBJ = dataGuid.currentGUID.SelectGuid;
    const isCL = currentOBJ.hasOwnProperty('CLGUID');
    setCL(isCL)
  }, [dispatch, form]);

  useEffect(() => {
    if (!isCL) dispatch(getCommodityListByGUID(dataGuid));
  }, [isCL])

  useEffect(() => {
    // BUG!!!
    if (milestoneConfig != undefined) {
      const dataSorted = milestoneConfig.sort(function (a: any, b: any) {
        const x = a.order;
        const y = b.order;
        if (x > y) {
          return 1;
        }
        if (x < y) {
          return -1;
        }
        return 0;
      });
      dataSorted.forEach((milestone: any) => {
        milestone.hidden = !milestone.visibleInTable;
      });
      setTableConfig(dataSorted);
    }
  }, [milestoneConfig]);

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    hideSelectColumn: false,
    bgColor: '#00BFFF',
  };

  const hideProgress = () => {
    Swal.close();
  };
  const onPopUpState = () => {
    setpopUpState(!popUpState);
  };

  return (
    <div className="commodityDetails">
      <>
        <div id="contentToprint">
          <React.Fragment>
            <div className="search">
              <div className="ml-6 col">
                <h2>{'Commodities - ' + numOrder}</h2>
                <Row>                  
                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    {/* <button type="button" className="btn btn-secondary button-icon"><i className="fas fa-file-csv fa-lg"></i></button> */}                    
                      {visiblePackingList && dataGuid ? (<PackingList groupName={groupName} CommodityList={dataGuid.currentGUID.SelectGuid} />) : null}
                  </div>
                </Row>
              </div>
            </div>
            <div className="pageContentIform">
              <Container fluid>
                <Row>
                  <div className="container">
                    <>{isLoading ? hideProgress() : null}</>
                  </div>
                  {CommodityList.length > 0 ? (
                    <>
                      <ITable
                        CountItems={CommodityList.length}
                        enableTemporaryView={false}
                        valuesSizePagination={valuesSizePagination}
                        handlerPaginationState={() => { }}
                        data={CommodityList}
                        isLoading={isLoading}
                        fields={milestoneConfig}
                        tableColumns={milestoneConfig}
                        headerColorT={'bg-primary text-white'}
                        handlePopUpState={onPopUpState}
                        groupName={groupNameModal}
                        itemsTree
                      />
                    </>
                  ) : null}
                </Row>
              </Container>
            </div>
          </React.Fragment>
        </div>
      </>
    </div>
  );
};
export default CommodityModal;
